import { Autocomplete, Props as AutocompleteProps } from '../Autocomplete/Autocomplete';
import { regions } from './regions';

type Props = Omit<AutocompleteProps<string>, 'options'>;

export const RegionAutocomplete = (props: Props) => {
  return <Autocomplete {...props} options={regions} />;
};
